import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useAuth from 'hooks/useAuth'
import { InputNumber, Slider, Card, Tag } from 'antd'
import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'
import { getTiersList } from "api";
import { useQuery } from 'react-query'
import { subscriptionsActions } from 'store/reducers/subscriptions/subscriptions'
import { useDispatch, useSelector } from 'react-redux'
import CustomButton from 'components/atoms/CustomButton'

const ChoosePlanPage = () => {
  const { t } = useTranslation();
  const [sits, setSits] = useState(1);
  const [tiers, setTiers] = useState([]);


  const navigate = useNavigate();
  const dispatch = useDispatch()

  const { data } = useQuery({
    queryKey: ['tiers'],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await getTiersList()
      setTiers(res?.resData?.data?.sort((a, b) => a.id - b.id) || [])
    }
  })

  const marks = {
    0: {
      style:  {fontSize: '12px', fontWeight: 400, color: '#828282', lineHeight: '20px', fontFamily: 'Inter', transform: 'translateX(-15%)'},
      label: 'Small'
    },
    4:  {
      style:  {fontSize: '12px', fontWeight: 400, color: '#828282', lineHeight: '20px', fontFamily: 'Inter'},
      label: 'Medium'
    },
    8:  {
      style:  {fontSize: '12px', fontWeight: 400, color: '#828282', lineHeight: '20px', fontFamily: 'Inter'},
      label: 'Large'
    },
    11:  {
      style:  {fontSize: '12px', fontWeight: 400, color: '#828282', lineHeight: '20px', fontFamily: 'Inter', transform: 'translateX(-90%)'},
      label: 'Custom'
    }
  };

  /* const marks = {
    0: {
      label: "Small",
      style: {
        color: "#0049EE",
        fontSize: "12px",
        fontWeight: 400,
      },
    },
    25: {
      label: "Medium",
      style: {
        color: "#0049EE",
        fontSize: "12px",
        fontWeight: 400,
      },
    },
    75: {
      label: "Large",
      style: {
        color: "#0049EE",
        fontSize: "12px",
        fontWeight: 400,
      },
    },
    100: {
      label: "Custom",
      style: {
        color: "#828282",
        fontSize: "12px",
        fontWeight: 400,
      },
    },

  }; */

  const handleChange = (val) => {
    setSits(val);
  };

  const selectedTier = tiers.find(
    (tier) => sits >= tier.min_seat && sits <= tier.max_seat
  );



  const maxSeats = tiers[tiers.length - 1]?.max_seat || 0;

  const selectPlan = (type) => {
    dispatch(
      subscriptionsActions.setPlan({
        sits: sits,
        tier: selectedTier,
        type: type
      })
    )
    localStorage.setItem('plan', JSON.stringify({
      sits: sits,
      tier: selectedTier,
      type: type
    }))
    navigate('/sign-up')
  }

  const handleContactUs = () => {
    window.location.href = 'mailto:Info@legalai.it';
  }

  useEffect(() => {
    const plan = JSON.parse(localStorage.getItem('plan'))
    setSits(plan?.sits || 1)
  }, [])


  

  return (
    <div className={`flex justify-center h-screen w-screen bg-white p-2`}>

      <div className="justify-left w-[730px] h-full bg-white rounded-2xl p-[40px] ">
        
        <div className="flex flex-col items-center">
          <p className="text-sm text-[#828282] font-normal">Step 1 {t('OF').toLowerCase()} 5</p>
          <p className="text-3xl text-black font-semibold">{t('Plans.ChoosePlanTitle')}</p>
          <p className="text-base text-[#828282] font-normal">{t('Plans.ChoosePlanSubtitle')}</p>
        </div>
        
        <div className="grid grid-cols-2 gap-8">
          <div className="mt-[40px] ">
            <p className="text-sm text-[#828282] font-normal">{t('Plans.ChooseUsersText')}</p>
            <InputNumber
              min={1}
              value={sits}
              controls={true}
              onChange={handleChange}
              style={{
                width: '100%',
                border: 'none',
                borderBottom: "2px solid #E3E3E8",
                outline: "none",
                borderRadius: "0px",
              }}

            />



          </div>

          <div className='mt-[40px] '>
            <p className='text-sm text-[#828282] font-normal'>{t("Plans.DiscountApplied")}</p>

            <Slider
              min={0}
              max={maxSeats + 1}
              marks={marks}
              defaultValue={Math.min(sits, maxSeats + 1)}
              value={Math.min(sits, maxSeats + 1)}
              disabled
              tooltip={{ open: false }}
              dotStyle={{ backgroundColor: '#94B1F4', width: '10px', height: '10px', marginTop: "-1px" }}
              activeDotStyle={{ backgroundColor: '#0049EE', width: '10px', height: '10px', marginTop: "-1px" }}
              styles={{
                rail: { height: 4, },
                tracks: { backgroundColor: "#0049EE", height: 4, },
              }}
            />



          </div>

        </div>


        <p className='text-sm text-[#828282] font-normal mt-4 mb-2'>{t("Plans.ChooseSubscriptionText")}</p>

        <div className='grid grid-cols-2 gap-8'>

          {sits > maxSeats ? (

            <>
              <Card
                size="small"
                style={{ width: '100%', padding: '12px' }}>
                <div className='flex justify-between'>
                  <p className='text-base font-normal text-black'> {t("Plans.Monthly")}</p>
                </div>


                <p className='text-2xl font-semibold text-black mt-[16px]' >{t('Plans.CustomPrice')}</p>
                <p className='text-sm font-medium text-[#595961] mt-1'>0€ per 6 giorni</p>
                <p className='text-sm font-medium text-[#595961] mt-1'> {t("Plans.MonthlyBilling")}</p>


                <Button
                  onClick={() => {
                    handleContactUs()
                  }}
                  variant="contained"
                  sx={{
                    marginTop: '32px',
                    width: '100%',
                    backgroundColor: '#0049EE',
                    fontSize: '14px',
                    textTransform: 'none',
                    boxShadow: 'none',
                    ':hover': {
                      backgroundColor: '#0049EE',
                      boxShadow: 'none',
                    }
                  }}>
                  {t('Contact us')}
                </Button>


                <p className='text-xs font-normal text-[#828282] mt-[20px]'>{t("Plans.MonthlyBillingSubtitle", { price: 'TBD' })}
                  <a rel="noreferrer" href="https://www.legalai.it/termini-condizioni" target="_blank" >
                    {t('Terms and Conditions')}
                  </a>

                </p>

              </Card>


              <Card
                size="small"
                style={{ width: '100%', padding: '12px'  }}>
                <div className='flex justify-between'>
                  <p className='text-base font-normal text-black'> {t("Plans.Yearly")}</p>

                 
                </div>


                <p className='text-2xl font-semibold text-black mt-[16px]' >{t('Plans.CustomPrice')}</p>
                <p className='text-sm font-medium text-[#595961] mt-1'>0€ per 6 giorni</p>
                <p className='text-sm font-medium text-[#595961] mt-1'> {t("Plans.YearlyBilling")}</p>


                <Button
                  onClick={() => {
                    handleContactUs()
                  }}
                  variant="contained"
                  sx={{
                    marginTop: '32px',
                    width: '100%',
                    backgroundColor: '#0049EE',
                    fontSize: '14px',
                    textTransform: 'none',
                    boxShadow: 'none',
                    ':hover': {
                      backgroundColor: '#0049EE',
                      boxShadow: 'none',
                    }
                  }}>
                  {t('Contact us')}
                </Button>


                <p className='text-xs font-normal text-[#828282] mt-[20px]'>{t("Plans.MonthlyBillingSubtitle", { price: 'TBD'})}
                  <a rel="noreferrer" href="https://www.legalai.it/termini-condizioni" target="_blank" >
                    {t('Terms and Conditions')}
                  </a>
                </p>

              </Card>
            </>

          ) : sits && sits > 0 ? (
            <>
              <Card
                size="small"
                style={{ width: '100%',  padding: '12px' }}>
                <div className='flex justify-between'>
                  <p className='text-base font-normal text-black'> {t("Plans.Monthly")}</p>

                  <Tag style={{
                    backgroundColor: 'white',
                    borderRadius: 100,
                    color: '#00B47E',
                    fontSize: '14px',
                    fontWeight: 600
                  }}>
                    {selectedTier?.discount_per_month}% {t("Plans.Discount")}
                  </Tag>
                </div>


                <p className='text-2xl font-semibold text-black mt-[16px]' >€{parseFloat(selectedTier?.price_per_seat_month).toFixed(2)} /{t("Plans.Month")}/user</p>
                <p className='text-sm font-medium text-[#595961] mt-1'>0€ per 6 giorni</p>
                <p className='text-sm font-medium text-[#595961] mt-1'>{parseFloat(selectedTier?.price_per_seat_month).toFixed(2)}€ {t("Plans.MonthlyBilling")}

                </p>


                <Button
                  onClick={() => {
                    selectPlan('month')
                  }}
                  variant="contained"
                  sx={{
                    marginTop: '32px',
                    width: '100%',
                    backgroundColor: '#0049EE',
                    fontSize: '14px',
                    textTransform: 'none',
                    boxShadow: 'none',
                    ':hover': {
                      backgroundColor: '#0049EE',
                      boxShadow: 'none',
                    }
                  }}>
                  {t('Plans.TryForFree')}
                </Button>


                <p className='text-xs font-normal text-[#828282] mt-[20px]'>{t("Plans.MonthlyBillingSubtitle", { price: parseFloat(selectedTier?.price_per_seat_month).toFixed(2) })}
                  <a rel="noreferrer" href="https://www.legalai.it/termini-condizioni" target="_blank" >
                    {t('Terms and Conditions')}
                  </a>
                </p>

              </Card>


              <Card
                size="small"
                style={{ width: '100%', padding: '12px'  }}>
                <div className='flex justify-between'>
                  <p className='text-base font-normal text-black'> {t("Plans.Yearly")}</p>

                  <Tag style={{
                    backgroundColor: 'white',
                    borderRadius: 100,
                    color: '#00B47E',
                    fontSize: '14px',
                    fontWeight: 600
                  }}>
                    {selectedTier?.discount_per_year}% {t("Plans.Discount")}
                  </Tag>
                </div>


                <p className='text-2xl font-semibold text-black mt-[16px]' >€{parseFloat(selectedTier?.price_per_seat_year).toFixed(2)} /{t("Plans.Month")}/user</p>
                <p className='text-sm font-medium text-[#595961] mt-1'>0€ per 6 giorni</p>
                <p className='text-sm font-medium text-[#595961] mt-1'> {parseFloat(selectedTier?.price_per_seat_year).toFixed(2)}€ {t("Plans.YearlyBilling")}</p>


                <Button
                  onClick={() => {
                    selectPlan('year')
                  }}
                  variant="contained"
                  sx={{
                    marginTop: '32px',
                    width: '100%',
                    backgroundColor: '#0049EE',
                    fontSize: '14px',
                    textTransform: 'none',
                    boxShadow: 'none',
                    ':hover': {
                      backgroundColor: '#0049EE',
                      boxShadow: 'none',
                    }
                  }}>
                  {t('Plans.TryForFree')}
                </Button>


                <p className='text-xs font-normal text-[#828282] mt-[20px]'>{t("Plans.MonthlyBillingSubtitle", { price: parseFloat(selectedTier?.price_per_seat_year).toFixed(2) })}
                  <a rel="noreferrer" href="https://www.legalai.it/termini-condizioni" target="_blank" >
                    {t('Terms and Conditions')}
                  </a>
                </p>

              </Card>
            </>
          ): <></>}

        </div>

      </div >


    </div >
  )
}

export default ChoosePlanPage
